import { cn } from '@/utils/helpers'

interface LoadingScreenProps {
  message?: string
  className?: string
  skeletonClassName?: string
}

export function LoadingScreen({ message = 'Loading...', className }: LoadingScreenProps) {
  return (
    <div
      className={cn(
        'bg-background/80 backdrop-blur-sm fixed inset-0 z-50 flex flex-col items-center justify-center',
        className
      )}
    >
      <div className="flex flex-col items-center justify-center space-y-8">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="flex space-x-2">
            <div className="h-4 w-4 animate-bounce rounded-full bg-primary [animation-delay:-0.3s]" />
            <div className="h-4 w-4 animate-bounce rounded-full bg-primary [animation-delay:-0.15s]" />
            <div className="animate-bounce bg-primary w-4 h-4 rounded-full" />
          </div>
          <p className="text-base font-bold text-white">{message}</p>
        </div>
      </div>
    </div>
  )
}
